





























import {
  Component,
  Vue,
} from 'vue-property-decorator';

import InfoLayout from '@/layouts/Info.vue';
import {
  i18n,
} from '@/plugins/vue-i18n';
import {
  metaInfoHelper,
} from '@/utils/meta-info-helper';


interface Question {
  title: string;
  content: string;
  showAnswer: boolean;
}

@Component({
  name: 'faq',
  components: {
    InfoLayout,
  },
  metaInfo() {
    const title = metaInfoHelper.getHeadTitle(i18n.t('views.faq.frequentlyAskedQuestions'));

    return {
      title,
      meta: [...metaInfoHelper.getHeaderOGMeta({ title })],
    };
  },
})
export default class Faq extends Vue {
  private readonly questions: Question[] = [
    {
      title: 'Как управлять коммерческим предложением',
      content: `Lorem ipsum dolor sit amet, consectetur
      adipiscing elit, sed do eiusmod tempor incididunt ut labore
      et dolore magna aliqua. Ut enim ad minim veniam, quis
      nostrud exercitation ullamco laboris nisi ut aliquip ex ea
      commodo consequat. Duis aute irure dolor in reprehenderit
      in voluptate velit esse cillum dolore eu fugiat nulla
      pariatur. Excepteur sint occaecat cupidatat non proident,
      sunt in culpa qui officia deserunt mollit anim id est
      laborum`,
      showAnswer: false,
    },
    {
      title: 'Как формируется ценообразование',
      content: `Lorem ipsum dolor sit amet, consectetur
      adipiscing elit, sed do eiusmod tempor incididunt ut labore
      et dolore magna aliqua. Ut enim ad minim veniam, quis
      nostrud exercitation ullamco laboris nisi ut aliquip ex ea
      commodo consequat. Duis aute irure dolor in reprehenderit
      in voluptate velit esse cillum dolore eu fugiat nulla
      pariatur. Excepteur sint occaecat cupidatat non proident,
      sunt in culpa qui officia deserunt mollit anim id est
      laborum`,
      showAnswer: false,
    },
    {
      title: 'Как управлять типами работ',
      content: `Lorem ipsum dolor sit amet, consectetur
      adipiscing elit, sed do eiusmod tempor incididunt ut labore
      et dolore magna aliqua. Ut enim ad minim veniam, quis
      nostrud exercitation ullamco laboris nisi ut aliquip ex ea
      commodo consequat. Duis aute irure dolor in reprehenderit
      in voluptate velit esse cillum dolore eu fugiat nulla
      pariatur. Excepteur sint occaecat cupidatat non proident,
      sunt in culpa qui officia deserunt mollit anim id est
      laborum`,
      showAnswer: false,
    },
    {
      title: 'Как управлять коммерческим предложением',
      content: `Lorem ipsum dolor sit amet, consectetur
      adipiscing elit, sed do eiusmod tempor incididunt ut labore
      et dolore magna aliqua. Ut enim ad minim veniam, quis
      nostrud exercitation ullamco laboris nisi ut aliquip ex ea
      commodo consequat. Duis aute irure dolor in reprehenderit
      in voluptate velit esse cillum dolore eu fugiat nulla
      pariatur. Excepteur sint occaecat cupidatat non proident,
      sunt in culpa qui officia deserunt mollit anim id est
      laborum`,
      showAnswer: false,
    },
  ];

  private handleShowAnswer(question: Question): void {
    question.showAnswer = !question.showAnswer; // eslint-disable-line no-param-reassign
  }
}
